export default "__VITE_ASSET__NNbh5jPV__"